import { Motorbike, User, Store, MessageCircleMore, MapPinHouse } from 'lucide-react';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { SEARCH_ORDER_FIELDS } from '@/utils/constants';
import { twColors } from '@/utils/tw-colors';
import useWindowSize from '@/utils/useWindowSize';

const { SHOP_NAME, CLIENT, ADDRESS, DELIVERY, COMMENTS } = SEARCH_ORDER_FIELDS;

const IconWrapper = ({ children, active }) => (
	<div
		className='flex items-center justify-center rounded-md p-1.5'
		style={{
			backgroundColor: active ? twColors.sky[200] : 'transparent',
		}}
	>
		{children}
	</div>
);

export const SearchOrderFields = ({
	orderSearchText,
	onChange,
	orderFieldsToSearch,
	setOrderFieldsToSearch,
}) => {
	const toggleField = field => {
		const newOrderFieldsToSearch = { ...orderFieldsToSearch };

		newOrderFieldsToSearch[field] = !newOrderFieldsToSearch[field];

		setOrderFieldsToSearch(newOrderFieldsToSearch);
	};

	// console.log('orderFieldsToSearch', orderFieldsToSearch);

	const { width: screenWidth } = useWindowSize();

	return (
		<FloatingTextinput
			value={orderSearchText}
			label={`${screenWidth > 599 ? 'Αναζήτηση' : 'Αναζ'} παραγγελιών`}
			// onChange={e => setForm({ ...form, firstname: e })}
			onChange={onChange}
			// onBlur={validateFirstname}
			// error={errorFirstname}
			// onFocus={onFocusShop}
			// size='lg'
			styleContainer={{ width: '380px' }}
			cnRightComponents='top-1.5'
			cnRightComponentLine='mt-1'
			rightComponents={[
				{
					key: SHOP_NAME,
					onClick: () => {
						toggleField(SHOP_NAME);
					},
					component: (
						<IconWrapper active={orderFieldsToSearch[SHOP_NAME]}>
							<Store color={twColors.slate[500]} size={18} className='mb-0 min-[1120px]:mb-0' />
						</IconWrapper>
					),
				},
				{
					key: CLIENT,
					onClick: () => {
						toggleField(CLIENT);
					},
					component: (
						<IconWrapper active={orderFieldsToSearch[CLIENT]}>
							<User color={twColors.slate[500]} size={18} className='mb-0 min-[1120px]:mb-0' />
						</IconWrapper>
					),
				},
				{
					key: ADDRESS,
					onClick: () => {
						toggleField(ADDRESS);
					},
					component: (
						<IconWrapper active={orderFieldsToSearch[ADDRESS]}>
							<MapPinHouse
								color={twColors.slate[500]}
								size={18}
								className='mb-0 min-[1120px]:mb-0'
							/>
						</IconWrapper>
					),
				},
				{
					key: DELIVERY,
					onClick: () => {
						toggleField(DELIVERY);
					},
					component: (
						<IconWrapper active={orderFieldsToSearch[DELIVERY]}>
							<Motorbike color={twColors.slate[500]} size={18} className='mb-0 min-[1120px]:mb-0' />
						</IconWrapper>
					),
				},
				{
					key: COMMENTS,
					onClick: () => {
						toggleField(COMMENTS);
					},
					component: (
						<IconWrapper active={orderFieldsToSearch[COMMENTS]}>
							<MessageCircleMore
								color={twColors.slate[500]}
								size={18}
								className='mb-0 min-[1120px]:mb-0'
							/>
						</IconWrapper>
					),
				},
			]}
		/>
	);
};
